import React, { useEffect, useState } from "react";
import { Box, Heading, Text, Button } from "@chakra-ui/react";
import { useParams, useNavigate } from "react-router-dom";
import reservationsService from "../../services/rentals/reservationsService";

export default function ReservationDetail() {
  const { id } = useParams();
  const [resv, setResv] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function load() {
      try {
        const r = await reservationsService.getReservation(id);
        setResv(r);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [id]);

  const handleCancel = async () => {
    try {
      await reservationsService.cancelReservation(id);
      navigate('/rentals/reservations');
    } catch (e) {
      console.error(e);
    }
  };

  if (loading) return <Box>Loading…</Box>;
  if (!resv) return <Box>Not found</Box>;

  return (
    <Box>
      <Heading size="md">Reservation {resv.reservationCode || resv._id}</Heading>
      <Text>Asset: {resv.asset && resv.asset.name}</Text>
      <Text>From: {resv.fromDate}</Text>
      <Text>To: {resv.toDate}</Text>
      <Text>Status: {resv.status}</Text>
      <Button mt={4} colorScheme="red" onClick={handleCancel}>Cancel reservation</Button>
    </Box>
  );
}
